module.exports = __webpack_public_path__ + "mainassets/img/bg1.084b2307.svg";